export  enum PathsENUM {
    ORGANIZATION =  "organization",
    TEAMS = "teams",
    APPS = "apps",
    DASHBOARD = "dashboard"
}